// extracted by mini-css-extract-plugin
export default {"content":"style_content__xOCS+","itemName":"style_itemName__Hq94A","leftSide":"style_leftSide__XtEfa","rightSide":"style_rightSide__IrBSS","type":"style_type__z5rar"};